// SVG Icons for Linko Labs website

export const CodeIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 16L6 24L14 32" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34 16L42 24L34 32" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28 8L20 40" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const AIIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="16" stroke={color} strokeWidth="3"/>
        <circle cx="24" cy="24" r="6" fill={color}/>
        <path d="M24 4V8" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M24 40V44" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M4 24H8" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M40 24H44" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M9.86 9.86L12.69 12.69" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M35.31 35.31L38.14 38.14" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M9.86 38.14L12.69 35.31" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M35.31 12.69L38.14 9.86" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const AutomationIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="8" stroke={color} strokeWidth="3"/>
        <path d="M24 12V16" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M24 32V36" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M12 24H16" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M32 24H36" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M15.5 15.5L18 18" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M30 30L32.5 32.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M15.5 32.5L18 30" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M30 18L32.5 15.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <circle cx="24" cy="6" r="3" fill={color}/>
        <circle cx="24" cy="42" r="3" fill={color}/>
        <circle cx="6" cy="24" r="3" fill={color}/>
        <circle cx="42" cy="24" r="3" fill={color}/>
    </svg>
)

export const ConsultingIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 6C24 6 28 14 28 20C28 26 24 30 24 30C24 30 20 26 20 20C20 14 24 6 24 6Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <circle cx="24" cy="20" r="3" fill={color}/>
        <path d="M24 30V38" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M18 42H30" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M16 38H32" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const ChatIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 10H40V32H26L18 40V32H8V10Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <circle cx="16" cy="21" r="2" fill={color}/>
        <circle cx="24" cy="21" r="2" fill={color}/>
        <circle cx="32" cy="21" r="2" fill={color}/>
    </svg>
)

export const DocumentIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6H30L38 14V42H12V6Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <path d="M30 6V14H38" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <path d="M18 22H32" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M18 28H32" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M18 34H26" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const RocketIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 6C24 6 36 12 36 28L24 42L12 28C12 12 24 6 24 6Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <circle cx="24" cy="20" r="4" stroke={color} strokeWidth="3"/>
        <path d="M12 28L6 30L12 36" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <path d="M36 28L42 30L36 36" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
    </svg>
)

export const SupportIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="18" stroke={color} strokeWidth="3"/>
        <circle cx="24" cy="24" r="8" stroke={color} strokeWidth="3"/>
        <path d="M24 6V16" stroke={color} strokeWidth="3"/>
        <path d="M24 32V42" stroke={color} strokeWidth="3"/>
        <path d="M6 24H16" stroke={color} strokeWidth="3"/>
        <path d="M32 24H42" stroke={color} strokeWidth="3"/>
    </svg>
)

export const CloudIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 34C7.58 34 4 30.42 4 26C4 22.13 6.77 18.93 10.4 18.18C10.78 12.55 15.37 8 21 8C25.08 8 28.62 10.34 30.47 13.73C31.27 13.58 32.12 13.5 33 13.5C39.08 13.5 44 18.42 44 24.5C44 30.58 39.08 35.5 33 35.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M12 34H33" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M24 26V42" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M20 30L24 26L28 30" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const CartIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 8H10L14 32H38L42 14H12" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="18" cy="40" r="3" stroke={color} strokeWidth="3"/>
        <circle cx="34" cy="40" r="3" stroke={color} strokeWidth="3"/>
    </svg>
)

export const HandshakeIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20L12 12H20L24 16L28 12H36L44 20" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4 20L16 32L24 28L32 36L44 28" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24 16V28" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const MegaphoneIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 18V30H14L26 40V8L14 18H8Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <path d="M32 16C34.5 18.5 34.5 29.5 32 32" stroke={color} strokeWidth="3" strokeLinecap="round"/>
        <path d="M38 12C42 16 42 32 38 36" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const TruckIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12H28V34H4V12Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <path d="M28 18H38L44 26V34H28V18Z" stroke={color} strokeWidth="3" strokeLinejoin="round"/>
        <circle cx="12" cy="36" r="4" stroke={color} strokeWidth="3"/>
        <circle cx="36" cy="36" r="4" stroke={color} strokeWidth="3"/>
    </svg>
)

export const BriefcaseIcon = ({ size = 48, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="14" width="36" height="28" rx="2" stroke={color} strokeWidth="3"/>
        <path d="M16 14V10C16 8 18 6 20 6H28C30 6 32 8 32 10V14" stroke={color} strokeWidth="3"/>
        <path d="M6 24H42" stroke={color} strokeWidth="3"/>
        <path d="M24 24V28" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    </svg>
)

export const LocationIcon = ({ size = 24, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
        <circle cx="12" cy="9" r="3" stroke={color} strokeWidth="2"/>
    </svg>
)

export const PhoneIcon = ({ size = 24, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.92V19.92C22 20.48 21.56 20.93 21 20.97C20.68 21 20.36 21 20.03 21C10.57 21 3 13.43 3 3.97C3.04 3.41 3.52 3 4.08 3H7.08C7.56 3 7.97 3.34 8.05 3.81C8.14 4.34 8.29 4.86 8.49 5.35C8.63 5.71 8.53 6.11 8.24 6.36L6.75 7.85C8.27 10.64 10.36 12.73 13.15 14.25L14.64 12.76C14.89 12.47 15.29 12.37 15.65 12.51C16.14 12.71 16.66 12.86 17.19 12.95C17.66 13.03 18 13.44 18 13.92V16.92H22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const EmailIcon = ({ size = 24, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="4" width="20" height="16" rx="2" stroke={color} strokeWidth="2"/>
        <path d="M2 6L12 13L22 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const GitHubIcon = ({ size = 24, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 16.42 4.87 20.17 8.84 21.5C9.34 21.58 9.5 21.27 9.5 21C9.5 20.77 9.5 20.14 9.5 19.31C6.73 19.91 6.14 17.97 6.14 17.97C5.68 16.81 5.03 16.5 5.03 16.5C4.12 15.88 5.1 15.9 5.1 15.9C6.1 15.97 6.63 16.93 6.63 16.93C7.5 18.45 8.97 18 9.54 17.76C9.63 17.11 9.89 16.67 10.17 16.42C7.95 16.17 5.62 15.31 5.62 11.5C5.62 10.39 6 9.5 6.65 8.79C6.55 8.54 6.2 7.5 6.75 6.15C6.75 6.15 7.59 5.88 9.5 7.17C10.29 6.95 11.15 6.84 12 6.84C12.85 6.84 13.71 6.95 14.5 7.17C16.41 5.88 17.25 6.15 17.25 6.15C17.8 7.5 17.45 8.54 17.35 8.79C18 9.5 18.38 10.39 18.38 11.5C18.38 15.32 16.04 16.16 13.81 16.41C14.17 16.72 14.5 17.33 14.5 18.26C14.5 19.6 14.5 20.68 14.5 21C14.5 21.27 14.66 21.59 15.17 21.5C19.14 20.16 22 16.42 22 12C22 6.48 17.52 2 12 2Z" fill={color}/>
    </svg>
)

export const LinkedInIcon = ({ size = 24, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" rx="2" stroke={color} strokeWidth="2"/>
        <path d="M8 11V16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        <path d="M8 8V8.01" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 16V13C12 11.9 12.9 11 14 11C15.1 11 16 11.9 16 13V16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 11V16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
)

export const CheckIcon = ({ size = 24, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
        <path d="M8 12L11 15L16 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const ArrowRightIcon = ({ size = 24, color = "#4873df" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 7L19 12L14 17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
